import { createComponent } from '@/shared'
import { getManufacturerRatings } from '@/api/productReviews'
import RatingWithCounter from '@/components/RatingWithCounter'

function renderRatings (ratings) {
  const groupedRatings = ratings.reduce((prev, current) => {
    return { ...prev, [current.id]: { rating: current.rating, count: current.count } }
  }, {})

  Array.from(document.querySelectorAll('[data-component="full-manufacturer-rating"]'))
    .forEach((element) => {
      const rating = groupedRatings[element.getAttribute('data-manufacturer-id')] || { rating: 0 }
      if (rating.rating > 0) {
        createComponent(element, RatingWithCounter, { rating: rating.rating, count: rating.count })
      }
    })
}

export function renderManufacturerRating (manufacturerId) {
  getManufacturerRatings([manufacturerId])
    .then(ratings => {
      renderRatings(ratings)
    })
}



// WEBPACK FOOTER //
// ./src/modules/renderManufacturerRating.js